import { render, staticRenderFns } from "./SmallDirectRecordSign.vue?vue&type=template&id=2551aafe&scoped=true"
import script from "./SmallDirectRecordSign.vue?vue&type=script&lang=ts"
export * from "./SmallDirectRecordSign.vue?vue&type=script&lang=ts"
import style0 from "./SmallDirectRecordSign.vue?vue&type=style&index=0&id=2551aafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551aafe",
  null
  
)

export default component.exports